<template>
	<div>
		<div class="layout mx-auto bg-whiteDashboard">
			<div class="flex flex-col h-screen">
				<header-home />
				<main class="mb-auto">
					<div class="flex mx-auto w-full my-4">
						<div
							class="flex-1 mr-1 text-center w-full uppercase bg-navyBlue py-1 font-bold text-xl rounded-md text-white"
						>
							<button>DRAFT</button>
						</div>
						<div
							class="flex-1 ml-1 text-center w-full uppercase bg-lightPurple py-1 font-bold text-xl rounded-md text-white"
						>
							<button>PUBLIKASI</button>
						</div>
					</div>
					<div class="w-full">
						<div class="w-full border border-gray-600 rounded-md ">
							<div class="flex flex-row h-10">
								<div class="flex-1 text-left">
									<img
										class="ml-4 mt-4"
										src="../../assets/wedding/dot-3.svg"
										alt="dot-3"
										srcset=""
									/>
								</div>
								<div class="flex-1 float-right -mt-1 mr-3">
									<img
										class="ml-3 mt-3 float-right"
										src="../../assets/wedding/left-arrow.svg"
										alt="dot-3"
										srcset=""
									/>
									<img
										class="ml-3 mt-3 float-right"
										src="../../assets/wedding/right-arrow.svg"
										alt="dot-3"
										srcset=""
									/>
								</div>
							</div>
							<div>
								<div class=" bg-white h-40"></div>
							</div>
						</div>
					</div>
				</main>
				<footer class="static">
					<div class=" mb-0 pb-0 h-full">
						<p class=" bg-navyBlue py-2 text-sm text-whiteBase">
							©2021 joinme.id | All Right Reserved
						</p>
					</div>
				</footer>
				<!-- Menu -->
				<div class="fixed bottom-0 w-full layout">
					<!-- menu -->
					<div class="flex bg-whiteBase p-4 text-sm">
						<div class="flex-1">
							<div
								class="flex flex-col mx-auto text-navyBlue  text-center cursor-pointer"
							>
								<img
									class="w-1/5 mx-auto mb-1"
									src="../../assets/wedding/bagian.svg"
									alt="dot-3"
									srcset=""
								/>
								<p class="font-bold">Bagian</p>
							</div>
						</div>
						<div class="flex-1">
							<div
								class="flex flex-col mx-auto text-navyBlue  text-center cursor-pointer"
							>
								<img
									class="w-1/5 mx-auto mb-1"
									src="../../assets/wedding/template.svg"
									alt="dot-3"
									srcset=""
								/>
								<p class="font-bold">Template</p>
							</div>
						</div>
						<div class="flex-1">
							<div
								class="flex flex-col mx-auto text-navyBlue  text-center cursor-pointer"
							>
								<img
									class="w-1/5 mx-auto mb-1"
									src="../../assets/wedding/reset.svg"
									alt="dot-3"
									srcset=""
								/>
								<p class="font-bold">Reset</p>
							</div>
						</div>
					</div>
					<!-- end menu -->
				</div>
				<!-- End Menu -->
			</div>
		</div>
	</div>
</template>
<script>
import Header from "../dashboard/items/Header.vue";
export default {
	name: "Wedding",
	components: {
		"header-home": Header,
	},
	data() {
		return {
			Selected: "",
			RekName: "",
			RekNumber: "",
			StartDate: "",
			EndDate: "",
			Password: "",
			ConfirmPassword: "",
		};
	},
	methods: {
		logOut: function() {
			this.$store.dispatch("logout").then(() => {
				this.$router.push("/login");
			});
		},
		updateAkun: function() {
			alert("updateAkun");
		},
	},
};
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Karla:wght@400;500;600;700&display=swap");
p,
h1,
h2,
h3,
h4,
h5,
span,
button,
div,
input,
ul,
li {
	font-family: "Karla", sans-serif;
}
.font-tebel {
	font-weight: 600;
}
.dot {
	height: 17px;
	width: 17px;
	border-radius: 50%;
	display: inline-block;
}
.dot-active {
	height: 17px;
	width: 17px;
	border-radius: 50%;
	display: inline-block;
}
.home-table {
	padding-top: 25px;
}
input,
select,
option {
	border: 1px solid #999999;
	border-radius: 5px;
}
.disable-form {
	border: 1px solid #dadada;
}
.date {
	border: 1px solid #cecece;
	padding-left: 8px;
	outline: none;
}
.add {
	max-width: 100%;
	height: auto;
	border-bottom-width: 3px;
	border-radius: 100%;
	border-color: #f9f9f9;
}
.pagination {
	display: inline-block;
}

.pagination button {
	color: black;
	padding: 6px 12px;
	text-decoration: none;
}

.pagination button.active {
	background-color: #16213e;
	color: white;
	border-radius: 5px;
}

.pagination button:hover:not(.active) {
	background-color: #ddd;
	border-radius: 5px;
}
</style>
